import { FC } from "react";
import {
    Box,
    useBreakpointValue,
    Flex,
    Heading,
    Grid,
    GridItem,
    Text,
} from "@smile2impress/components/relaunch";
import { Picture } from "@smile2impress/components/relaunch";

import { CtaButton } from "components/CtaButton";

import { ListItem } from "./components/ListItem";
import { VerticalListWithImageProps } from "./VerticalListWithImage.types";

export const VerticalListWithImage: FC<VerticalListWithImageProps> = ({
    content,
    headingAs,
}) => {
    const isMobile = useBreakpointValue({
        base: true,
        tablet: true,
        desktop: false,
    });
    const {
        title,
        subtitle,
        cta,
        bgImage,
        items,
        numberedItems = false,
    } = content;

    return (
        <Box as="section" px={[0, 0, 4]}>
            <Grid
                gridTemplateColumns={[
                    "repeat(6, 1fr)",
                    "repeat(6, 1fr)",
                    "repeat(24, 1fr)",
                ]}
                gridColumnGap={[2]}
            >
                <GridItem colStart={[1, 1, 1]} colEnd={[7, 7, 24]}>
                    <Flex
                        direction="row"
                        justifyContent="space-between"
                        mb={[3, 3, 4]}
                    >
                        <Flex direction="column" maxW={["100%", "100%", "65%"]}>
                            <Heading
                                maxW="800px"
                                textStyle={["title1"]}
                                color="text.base"
                                as={headingAs}
                                lineHeight={["97%", "97%", "100%"]}
                            >
                                {title}
                            </Heading>
                            {subtitle && (
                                <Text
                                    maxW="700px"
                                    mt={[1, 1, 0.7]}
                                    textStyle={["body"]}
                                    color="text.base"
                                >
                                    {subtitle}
                                </Text>
                            )}
                        </Flex>
                        {!isMobile && cta && (
                            <Box alignSelf="flex-end">
                                <CtaButton {...cta} />
                            </Box>
                        )}
                    </Flex>
                </GridItem>
            </Grid>
            <Flex
                direction={["column", "column", "row"]}
                justifyContent="space-between"
            >
                {!isMobile && (
                    <Flex flexBasis={"45%"} borderRadius="sm" overflow="hidden">
                        <Picture {...bgImage} />
                    </Flex>
                )}
                <Flex
                    direction="column"
                    gap={[3, 3, 4]}
                    flexBasis={["100%", "100%", "45%"]}
                >
                    {items.map((item, index) => (
                        <Flex key={index}>
                            <ListItem
                                {...item}
                                {...(numberedItems ? { index } : {})}
                            />
                        </Flex>
                    ))}
                </Flex>
                {isMobile && cta && (
                    <Box mx={[2, 2, 0]} mt={3}>
                        <CtaButton {...cta} />
                    </Box>
                )}
            </Flex>
        </Box>
    );
};
